import axios from "axios";

export default {
   getTemplate() {
      return axios.get("/class-template").then((response) => {
         return response.data;
      });
   },
   getTemplateDataSource(params) {
      return axios
         .get("/class-template/datasource", { params })
         .then((response) => {
            return response.data;
         });
   },
   getTemplatebyID(id) {
      return axios.get("/class-template/" + id).then((response) => {
         return response.data;
      });
   },
   createTemplate(formdata) {
      return axios.post("/class-template", formdata).then((response) => {
         return response.data;
      });
   },
   updateTemplate(id, formdata) {
      return axios.post("/class-template/" + id, formdata).then((response) => {
         return response.data;
      });
   },
   deactivateTemplate(id) {
      return axios
         .put("/class-template/" + id + "/deactivate")
         .then((response) => {
            return response.data;
         });
   },
   reactivateTemplate(id) {
      return axios
         .put("/class-template/" + id + "/reactivate")
         .then((response) => {
            return response.data;
         });
   },
   destroyTemplate(id) {
      return axios
         .delete("/class-template/" + id + "/delete")
         .then((response) => {
            return response.data;
         });
   },
};
